// extracted by mini-css-extract-plugin
module.exports = {"title":"color-blocks_title__AHiLj","container":"color-blocks_container__2nhxC","rail":"color-blocks_rail__3qAbc"};